import { useRef } from 'react'

import {
  ChartTriggersServiceInterface,
  ChartTriggersSeriviceConstructor,
} from 'common/builder/components/chart/FlowChart/lib/services/ChartTriggerService/ChartTriggersServiceInterface'

export const useChartTriggersService = (
  serviceConstructor: ChartTriggersSeriviceConstructor,
  builderId: string,
): ChartTriggersServiceInterface => {
  const instance = useRef<ChartTriggersServiceInterface>()

  if (!instance.current) {
    instance.current = new serviceConstructor(builderId)
  }

  return instance.current
}
